
function componentToHex(c: number) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

function rgbToHex(r: number, g: number, b: number) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function hexToRgb(hex: string) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return {
    r: result ? parseInt(result[1], 16) : 255,
    g: result ? parseInt(result[2], 16) : 255,
    b: result ? parseInt(result[3], 16): 255
  };
}

function hexToRgbAlt(hex: string) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return {
    r: result ? parseInt(result[1], 16)/255 : 1,
    g: result ? parseInt(result[2], 16)/255 : 1,
    b: result ? parseInt(result[3], 16)/255: 1
  };
}


let recolorCanvas = function (canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, color: ColorRGB) {
  let imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let data = imgData.data;
  let tolerance = 128;

  if (data && data.length) {
    for (let i = 0; i < data.length; i += 4) {
        const red = data[i + 0];
        const green = data[i + 1];
        const blue = data[i + 2];
        const alpha = data[i + 3];

        let newcolor = color;
        
        // change blueish pixels to the new color
        if (newcolor) {
          data[i + 0] = newcolor.r;
          data[i + 1] = newcolor.g;
          data[i + 2] = newcolor.b;
          data[i + 3] = alpha;
        }
    }
  }
  ctx.putImageData(imgData, 0, 0);
}

let blendColorCanvas = function (canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, color: ColorRGB) {
  let imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let data = imgData.data;
  let tolerance = 128;
  let original = {
    r: 255,
    g: 255,
    b: 255
  }

  if (data && data.length) {
    for (let i = 0; i < data.length; i += 4) {
        const red = data[i + 0];
        const green = data[i + 1];
        const blue = data[i + 2];
        const alpha = data[i + 3];

        let newcolor = undefined as ColorRGB|undefined;
        let deltaR = 0;
        let deltaG = 0;
        let deltaB = 0;
        if ((red <= (original.r + tolerance)) && (red >= (original.r - tolerance))) {
          if ((green <= (original.g + tolerance)) && (green >= (original.g - tolerance))) {
            if ((blue <= (original.b + tolerance)) && (blue >= (original.b - tolerance))) {
              newcolor = color;
              deltaR = red - original.r;
              deltaG = green - original.g;
              deltaB = blue - original.b;
            }
          }
        }
        
        // change blueish pixels to the new color
        if (newcolor) {
          data[i + 0] = newcolor.r + (deltaR + deltaG + deltaB) / 3;
          data[i + 1] = newcolor.g + (deltaR + deltaG + deltaB) / 3;
          data[i + 2] = newcolor.b + (deltaR + deltaG + deltaB) / 3;
          data[i + 3] = alpha;
        }
        if (alpha < 100) {
          data[i + 3] = Math.sqrt(alpha); // hide transparent color as they're mostly unused in the template
        }
    }
  }
  ctx.putImageData(imgData, 0, 0);
}

let colorizeAlphaCanvas = function (canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D, color: ColorRGB, alphaThreshold: number) {
  let imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  let data = imgData.data;
  let tolerance = 128;
  let original = {
    r: 255,
    g: 255,
    b: 255
  }

  if (data && data.length) {
    for (let i = 0; i < data.length; i += 4) {
        const red = data[i + 0];
        const green = data[i + 1];
        const blue = data[i + 2];
        const alpha = data[i + 3];

        let newcolor = undefined as ColorRGB|undefined;

        if (alpha < alphaThreshold) {
          newcolor = color;
        }
        
        // change blueish pixels to the new color
        if (newcolor) {
          data[i + 0] = newcolor.r;
          data[i + 1] = newcolor.g;
          data[i + 2] = newcolor.b;
          data[i + 3] = 255;
        }
    }
  }
  ctx.putImageData(imgData, 0, 0);
}

export {
  componentToHex,
  rgbToHex,
  hexToRgb,
  hexToRgbAlt,
  recolorCanvas,
  blendColorCanvas,
  colorizeAlphaCanvas,
}